import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { SUBMETRIC_FONT_SIZE, SUBMETRIC_ROW_WIDTHS } from '../helper';
import DisplaySubMetric from './DisplaySubMetric';
import { ControlledExpander } from './Util/ControlledExpander';
import { BaseMetric } from '@amzn/aet-galactus-kit';

interface CCXSubMetricComponentProps {
  metric: BaseMetric;
  titleStringId: string;
  titleDefaultMessage: string;
  definitionStringId: string;
  definitionDefaultMessage: string;
}

const CCXSubMetricComponent: React.FC<CCXSubMetricComponentProps> = ({
  metric,
  titleStringId,
  titleDefaultMessage,
  definitionStringId,
  definitionDefaultMessage,
}: CCXSubMetricComponentProps): React.ReactElement => {
  return (
    <Row
      alignmentVertical='top'
      width='100%'
      widths={SUBMETRIC_ROW_WIDTHS}
      spacing='none'
      spacingInset='none none 200'
    >
      <ControlledExpander
        title={
          <Text
            type={SUBMETRIC_FONT_SIZE}
            className='lighthouse-submetric-long-word-treatment'
          >
            <FormattedMessage
              id={titleStringId}
              defaultMessage={titleDefaultMessage}
            />
          </Text>
        }
        type='list'
      >
        <Text type={SUBMETRIC_FONT_SIZE}>
          <FormattedMessage
            id={definitionStringId}
            defaultMessage={definitionDefaultMessage}
          />
        </Text>
      </ControlledExpander>
      <DisplaySubMetric value={metric.datapoint} isPercentage isBold />
      <DisplaySubMetric
        value={metric.networkAverage!}
        isPercentage
        datapointNull={metric.datapoint === null}
      />
    </Row>
  );
};

export default CCXSubMetricComponent;
